<template lang="pug">
  thead
    tr
      th(:colspan="columns.length", v-html="title")
    tr
      table-header-cell(
        v-for="column in columns", 
        :key="column.id",
        :data="column",
        @toggleOrder="toggleOrder(column.id)"
      )
</template>

<script>
import TableHeaderCell from './table-header-cell'

export default {
  name: 'table-header',
  props: ['columns', 'order', 'orderBy', 'title'],
  components: { TableHeaderCell },
  methods: {
    toggleOrder (id) {
      this.$emit('toggleOrder', id)
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>




// WEBPACK FOOTER //
// table-header.vue?1506a836